import FieldsIdentity from '@/users/components/fields/identity'
import FieldsMarketing from '@/users/components/fields/marketing'
import FieldsRoles from '@/users/components/fields/roles'
import FieldsSecurity from '@/users/components/fields/security'
import FieldsStatus from '@/users/components/fields/status'
import {Box, Grid, Typography} from '@mui/material'
import React, {useEffect} from 'react'
import {Create, SaveButton, SimpleForm, Toolbar, useNotify, useTranslate} from 'react-admin'

export default function ProducerUserCreate() {

    const translate = useTranslate()

    useEffect((): any => {
        document.title = 'Nouvel utilisateur'
    }, [])

    return (
        <Create title={'Nouvel utilisateur'}>
            <SimpleForm
                warnWhenUnsavedChanges
                noValidate
                toolbar={<FormToolbar/>}
                sx={{
                    padding: {
                        md: '32px',
                        xs: '16px'
                    }
                }}
            >
                <Typography variant="h4">Création de l'utilisateur</Typography>
                <Grid
                    container
                    spacing={5}
                >
                    <Grid item xs={12} md={6} display={'flex'} flexDirection={'column'} gap={3}>
                        <FieldsStatus/>
                        <FieldsIdentity/>
                        <FieldsMarketing/>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FieldsSecurity/>
                        <FieldsRoles isCreate={true}/>
                    </Grid>
                </Grid>
            </SimpleForm>
        </Create>
    )
}

const FormToolbar = () => {

    const notify = useNotify()

    return (
        <Toolbar className="fixed-bottom" sx={{display: 'flex', justifyContent: 'space-between'}}>
            <Box sx={{display: 'flex', gap: 5}}>
                <SaveButton
                    className="save"
                    label="Enregistrer"
                    mutationOptions={{
                        onSuccess: event => {
                            notify('Utilisateur créé', {
                                type: 'success',
                                messageArgs: {smart_count: 1}
                            })
                        }
                    }}
                />
            </Box>
        </Toolbar>
    )
}
